/**
 * Checks if the member has the provided permission.
 *
 * @param member The member to check the permission for.
 * @param permissionName The name of the permission to check.
 * @returns True if the member has the permission, false otherwise.
 */
export function hasPermission({
  member,
  permissionName
}) {
  if (!member || !("permissions" in member)) {
    return false;
  }
  return member.permissions?.some(permission => permission.name === permissionName && permission.allowed) ?? false;
}

/**
 * Checks if the member has the permission to create a group.
 * Does not check the roles of the member, it only checks for the specific permission.
 * Therefore this only applies to group managers.
 *
 * @param member The member to check the permission for.
 * @returns True if the member has the permission, false otherwise.
 */
export function hasCreateGroupsPermission({
  member
}) {
  return hasPermission({
    member,
    permissionName: "createGrp"
  });
}

/**
 * Checks if the member holds a Sphere XG seat of the workspace.
 *
 * @param member The member to check the permission for.
 * @returns True if the member holds a Sphere XG seat, false otherwise.
 */
export function hasXgSeatPermission({
  member
}) {
  return hasPermission({
    member,
    permissionName: "activeSeat"
  });
}

/**
 * Checks if the member holds a SCENE seat (license) of the workspace.
 *
 * @param member The member to check the permission for.
 * @returns True if the member holds a SCENE seat, false otherwise.
 */
export function hasSceneSeatPermission({
  member
}) {
  return hasPermission({
    member,
    permissionName: "sceneSeat"
  });
}